// extracted by mini-css-extract-plugin
module.exports = {"Features":"Features_Features__m4Q4L","list":"Features_list__bk6Fs","item":"Features_item__SUGnK"};